module.exports = __webpack_public_path__ + "img/self_bg.04803624.png";